import React, { useMemo } from 'react';
import styled from 'styled-components';
import orderReceived from './order-received.mp4';
import orderInProcess from './order-in-process.mp4';
import orderReady from './order-ready.mp4';
import { VideoPlayer } from '../../../video-player/VideoPlayer';
import { OrderViewDefaultStatus } from '../../view/default/OrderViewDefault';
import { XCard } from '../../../x/card/XCard';
import { XBox } from '@orderx/lab/ui';

const Wrapper = styled(XCard)`
    position: relative;

    .video-container {
        background-color: #161616;
        border-radius: var(--border-radius-large);
        overflow: hidden;
        margin: 0 auto;
        min-height: 240px;
        width: 100%;
    }

    .text {
        width: 100%;
        color: var(--x-color-success);
        position: absolute;
        bottom: calc(2 * var(--ui-spacing));
        padding: var(--ui-spacing);
        text-align: center;
        font-size: var(--x-font-size-3);
        font-weight: bold;
        z-index: 1;
    }
`;

interface Props {
    orderState: any;
}

export function OrderStatusAnimation({ orderState }: Props) {
    const status = orderState.status;

    const videoUrl = useMemo(() => {
        if ([OrderViewDefaultStatus.PLACED].includes(status)) {
            return orderReceived;
        } else if ([OrderViewDefaultStatus.DELIVERED, OrderViewDefaultStatus.READY].includes(status)) {
            return orderReady;
        } else {
            return orderInProcess;
        }
    }, [status]);

    return (
        <>
            <Wrapper gap={1} padding={1}>
                <div className="text">{orderState.title}</div>

                <XBox className="video-container" padding={4}>
                    <VideoPlayer src={videoUrl} height={240} />
                </XBox>
            </Wrapper>
        </>
    );
}
